import React from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import TreatmentText from '../../TreatmentText'
import TreatmentOutcome from '../../TreatmentOutcome'
import TreatmentSubmitModule from '../../TreatmentSubmitButton'
import ArrestType from './ArrestType'
import InitialRhythm from './InitialRhythm'
import CPRQuality from './CPRQuality'
import DefibUsed from './DefibUsed'
import AirwayManagement from './AirwayManagement'
import OutcomeAtScene from './OutcomeAtScene'
import { useState } from 'react'

const CardiacArrest = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Cardiac Arrest</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <ArrestType
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <InitialRhythm
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <CPRQuality
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <DefibUsed
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <AirwayManagement
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <OutcomeAtScene
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentOutcome
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          lg={8}
        />
        <TreatmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentSubmitModule
          submitModule={submitModule}
          moduleValues={moduleValues}
          moduleName="Cardiac Arrest"
        />
      </Grid>
    </Box>
  )
}

export default CardiacArrest
